module.exports = __webpack_public_path__ + "img/logo.6c1252c7.svg";